import { render, staticRenderFns } from "./TaskManagerCalendarIndex.vue?vue&type=template&id=34bf24f8&scoped=true"
import script from "./TaskManagerCalendarIndex.vue?vue&type=script&lang=js"
export * from "./TaskManagerCalendarIndex.vue?vue&type=script&lang=js"
import style0 from "./TaskManagerCalendarIndex.vue?vue&type=style&index=0&id=34bf24f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf24f8",
  null
  
)

export default component.exports